import React, { useState } from 'react';
import {
	Box,
	IconButton,
	Drawer,
	List,
	ListItemButton,
	ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { navItems } from './Header';

export const MobileHeader: React.FC = () => {
	const [drawerOpen, setDrawerOpen] = useState(false);

	return (
		<>
			<Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
				<Box
					component="img"
					src="/logo.png"
					sx={{ maxHeight: '100px' }}
				/>

				{navItems.length > 0 && (
					<IconButton onClick={() => setDrawerOpen(true)}>
						<MenuIcon />
					</IconButton>
				)}
			</Box>

			<Drawer
				anchor="left"
				open={drawerOpen}
				onClose={() => setDrawerOpen(false)}
			>
				<Box
					sx={{
						width: 250,
						p: 2,
						backgroundColor: '#FAFAFB',
						height: '100%',
					}}
				>
					<Box sx={{ display: 'flex', justifyContent: 'center', mb: 5 }}>
						<Box
							component="img"
							src="/logo.png"
							sx={{ maxHeight: '100px' }}
						/>
					</Box>

					<List>
						{navItems.map((item) => (
							<ListItemButton
								key={item.label}
								component="a"
								href={item.href}
								onClick={() => setDrawerOpen(false)}
							>
								<ListItemText primary={item.label} />
							</ListItemButton>
						))}
					</List>
				</Box>
			</Drawer>
		</>
	);
};